import React from 'react';
import { notification } from 'antd';
import { UploadChangeParam } from 'antd/lib/upload';
import { InjectedIntl, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  IElement,
  AppState,
  changeSelection,
  updateElementProp,
  Status,
} from '../../../../../redux/modules';
import { Upload } from '../../../../../components';
import {
  uploadFile,
  validateDimensions,
  regenerateThumbnail,
} from '../../../../../utils';
import {
  CustomImageVideoElementInput,
  ImageVideoElementContainer,
  CustomLabelImageVideoElement,
  FlexImageVideoElementContainer,
} from '../../styles';

interface IProps {
  creativeId: string;
  index: number;
  element: IElement;
  updateElementProp?: any;
  changeSelection?: any;
  intl?: InjectedIntl;
  status: Status;
}

interface IState {
  disabled?: boolean;
  isPosting?: boolean;
}

class ImageElementClass extends React.PureComponent<IProps, IState> {
  state: IState = {};

  handleChangeUpload = async (event: UploadChangeParam) => {
    const { element, intl } = this.props;

    if (this.state.isPosting) {
      return;
    }

    if (!element.url) {
      return this.handleError(
        this.props.intl!.formatMessage({
          id: 'editor.error.uploadVideo.default',
        })
      );
    }

    if (event.file) {
      this.setState({ isPosting: true });
    }

    try {
      const newUrl = await uploadFile(event.file.originFileObj);
      const { error, data } = await validateDimensions(element.url, newUrl);

      if (error) {
        this.setState({ isPosting: false });
        return this.handleError(
          intl!.formatMessage(
            {
              id: `editor.error.uploadImage.${error}`,
            },
            { ...data }
          )
        );
      }

      this.props.updateElementProp(this.props.creativeId, 'url', data.url);

      await regenerateThumbnail(this.props.creativeId);

      this.handleSuccess(
        this.props.intl!.formatMessage({
          id: 'editor.uploadImage.success',
        })
      );
    } catch (error) {
      this.handleError(
        this.props.intl!.formatMessage({
          id: 'editor.error.uploadImage.default',
        })
      );
    }

    this.setState({ isPosting: false });
  };

  handleEnter = (index: number) => {
    this.props.changeSelection('element', index);
  };

  handleSuccess = (message: string) =>
    notification.open({
      message: this.props.intl!.formatMessage({ id: 'success' }),
      className: 'success',
      description: message,
      duration: 45,
    });

  handleError = (error: string) =>
    notification.open({
      message: this.props.intl!.formatMessage({ id: 'error' }),
      className: 'error',
      description: error,
      duration: 45,
    });

  render() {
    const {
      updateElementProp,
      creativeId,
      element,
      index,
      status,
    } = this.props;

    return (
      <ImageVideoElementContainer
        onClick={() => this.handleEnter(index)}
        key={`row_img_${index}`}
      >
        <CustomLabelImageVideoElement>
          {element.name}
        </CustomLabelImageVideoElement>
        <FlexImageVideoElementContainer>
          <CustomImageVideoElementInput
            value={element.url || ''}
            placeholder={'editor.info.placeholer.element.image'}
            onChange={event =>
              updateElementProp(creativeId, 'url', event.target.value)
            }
            disabled={
              element.locked ||
              status === Status.PUBLISHED ||
              status === Status.PENDING_VALIDATION
            }
          />
          <Upload
            disabled={
              element.locked ||
              status === Status.PUBLISHED ||
              status === Status.PENDING_VALIDATION
            }
            showUploadList={false}
            onChange={this.handleChangeUpload}
          />
        </FlexImageVideoElementContainer>
      </ImageVideoElementContainer>
    );
  }
}

export const ImageElement = connect(
  (state: AppState, props: IProps) => ({}),
  {
    changeSelection,
    updateElementProp,
  }
)(injectIntl(ImageElementClass as any));
